import { setEditCardModal } from '../../../../../store/workspace/slice';
import { BillingAddressIcon } from '../../../../../assets/icons';
import { useDispatch } from '../../../../../store/store';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import { useState } from 'react';

/**
 * Billing address form of a saved card. The `edit_payment_method` endpoint it
 * belongs to is not wired up yet, so confirming currently does nothing.
 */
export default function EditCard() {
    const [city, setCity] = useState('');
    const dispatch = useDispatch();
    const [country, setCountry] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [fullName, setFullName] = useState('');
    const [billingAddress, setBillingAddress] = useState('');

    const closeModal = () => dispatch(setEditCardModal(false));

    return (
        <Modal
            size='sm'
            actions='both'
            restrictActionsWidth
            closeFunc={closeModal}
            title='Change Billing address'
            icon={<BillingAddressIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Primary',
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'Confirm',
                type: 'Primary',
            }}
        >
            <Input
                label=' Full Name'
                placeholder=''
                type='text'
                value={fullName}
                onChange={setFullName}
            />
            <Input
                label='Billing Address'
                placeholder=''
                type='text'
                value={billingAddress}
                onChange={setBillingAddress}
            />
            <div className={styles.city_and_zip}>
                <Input
                    label='City'
                    placeholder=''
                    type='text'
                    value={city}
                    onChange={setCity}
                />
                <Input
                    label='Zip Code'
                    placeholder=''
                    type='text'
                    value={zipCode}
                    onChange={setZipCode}
                />
            </div>
            <Input
                label='Country'
                placeholder=''
                type='text'
                value={country}
                onChange={setCountry}
            />
        </Modal>
    );
};
